﻿import { useState, useCallback } from 'react';
import { api } from '@/services/api';
import { config } from '@/config/env';

export interface CustomerDetail {
  codcliente: string;
  ragsociale: string;
  tipologia: string;
  indirizzo: string;
  cap: string;
  localita: string;
  prov: string;
  regioncountry: string;
  stato: string;
  telefono: string;
  email: string;
  zona: string;
  salesmanager?: { codice: string; nome: string; cognome: string };
  [key: string]: unknown;
}

export function useCustomerDetail() {
  const [customer, setCustomer] = useState<CustomerDetail | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchCustomer = useCallback(async (codcliente: string) => {
    if (!codcliente || codcliente === '0') { setCustomer(null); return; }
    setLoading(true);
    try {
      const data = await api.get<CustomerDetail>(
        'clienti/cliente/' + config.SITE + '/' + codcliente + '/' + config.NOME_APP
      );
      setCustomer(data);
    } catch {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clear = useCallback(() => setCustomer(null), []);

  return { customer, loading, fetchCustomer, clear };
}
